import type { UserPublic } from '@repo/types/users';

import { MessageCircleIcon } from 'lucide-react';

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { useMessageTeacher } from '@/hooks/parent';
import { getAvatar } from '@/utils/getAvatar';

/** Which child this teacher teaches, and in which group. */
export interface TeacherContext {
  childId: number;
  childName: string;
  groupId: number;
  groupName: string;
}

interface TeacherCardProps {
  teacher: UserPublic;
  contexts: TeacherContext[];
}

export function TeacherCard(teacherCardProps: TeacherCardProps) {
  const { teacher, contexts } = teacherCardProps;
  const { messageTeacher, isPending } = useMessageTeacher();

  const fullName = `${teacher.name} ${teacher.surname}`.trim();
  const initials = `${teacher.name.charAt(0)}${teacher.surname.charAt(0)}`.toUpperCase();

  return (
    <li className={'border-border-primary bg-card/75 flex flex-wrap items-center gap-3 rounded-xl border p-3'}>
      <Avatar className={'size-10'}>
        <AvatarImage src={getAvatar(teacher.avatarURL)} alt={fullName} />
        <AvatarFallback>{initials}</AvatarFallback>
      </Avatar>

      <div className={'flex min-w-0 flex-col gap-1'}>
        <span className={'text-foreground text-sm font-medium'}>{fullName}</span>
        <div className={'flex flex-wrap gap-1'}>
          {contexts.map((context) => (
            <Badge key={`${context.childId}-${context.groupId}`} variant={'muted'} size={'sm'}>
              {context.childName} — {context.groupName}
            </Badge>
          ))}
        </div>
      </div>

      <Button variant={'outline'} size={'sm'} className={'ms-auto'} disabled={isPending} onClick={() => messageTeacher(teacher.id)}>
        <MessageCircleIcon />
        Napisz wiadomość
      </Button>
    </li>
  );
}
